const markerIcon = `<svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.78865 0.246094C6.68892 0.248645 4.67593 1.08319 3.19119 2.56667C1.70646 4.05015 0.871214 6.06145 0.868661 8.15941C0.866181 9.87391 1.42676 11.5419 2.4644 12.9074C2.4644 12.9074 2.68039 13.1912 2.7151 13.2324L8.78865 20.3891L14.8647 13.2293C14.8967 13.1909 15.1129 12.9071 15.1129 12.9071L15.114 12.9054C16.151 11.5404 16.7112 9.87313 16.7086 8.15941C16.7061 6.06145 15.8708 4.05015 14.3861 2.56667C12.9014 1.08319 10.8884 0.248645 8.78865 0.246094ZM8.78865 11.037C8.21904 11.037 7.66223 10.8682 7.18861 10.552C6.715 10.2358 6.34586 9.78642 6.12788 9.26061C5.9099 8.7348 5.85287 8.15622 5.96399 7.59802C6.07512 7.03983 6.34941 6.5271 6.75219 6.12466C7.15496 5.72223 7.66813 5.44816 8.22679 5.33713C8.78546 5.2261 9.36453 5.28309 9.89078 5.50088C10.417 5.71868 10.8668 6.0875 11.1833 6.56072C11.4997 7.03393 11.6686 7.59028 11.6686 8.15941C11.6678 8.92233 11.3641 9.65375 10.8242 10.1932C10.2843 10.7327 9.55221 11.0361 8.78865 11.037Z" />
</svg>
`;

/**
 * Initialise the map locations block.
 */
function init_map_locations() {
	document.querySelectorAll( '.wp-block-kaplan-locations-map' ).forEach( ( el ) => {
		const map = el.querySelector( '.wp-block-getwid-map' );
		const cards = el.querySelectorAll( '.kaplan-map-locations-card' );

		// Bail if we don't have a map or cards.
		if ( ! map || ! cards ) {
			return;
		}

		const markers = map.querySelectorAll( 'div[role="button"]' );

		markers.forEach( ( marker, i ) => {
			const svg = document.createElement( 'div' );
			svg.setAttribute( 'class', 'kaplan-map-locations-card__marker' );
			svg.innerHTML = markerIcon;
			marker.appendChild( svg );
		} );

		cards.forEach( ( card, i ) => {
			 // Fallback to card index for back compat.
			const index = typeof card.dataset.index !== 'undefined' ? card.dataset.index : i;

			card.addEventListener( 'mouseenter', () => {
				card.classList.add( 'kaplan-map-locations-card--active' );
				map.querySelectorAll( 'div[role="dialog"] button[type="button"]' ).forEach( button => button?.click() );
				markers[index]?.querySelector( '.kaplan-map-locations-card__marker' ).classList.add( 'kaplan-map-locations-card__marker--active' );
				markers[index]?.click();
			} );

			card.addEventListener( 'mouseleave', () => {
				map.querySelectorAll( 'div[role="dialog"] button[type="button"]' ).forEach( button => button?.click() );
				card.classList.remove( 'kaplan-map-locations-card--active' );
				markers[index]?.querySelector( '.kaplan-map-locations-card__marker' ).classList.remove( 'kaplan-map-locations-card__marker--active' );
			} );
		} );
	} );
}

// Attempt to initialise for 2 seconds.
window.addEventListener( 'load', () => {
	let iterations = 0;
	const check = setInterval( () => {
		if ( window.google && document.querySelector( '.wp-block-getwid-map .gm-style' ) ) {
			clearInterval( check );
			init_map_locations();
		}
		if ( iterations++ > 10 ) {
			clearInterval( check );
		}
	}, 200 );
} );
